import { makeAutoObservable } from 'mobx';

export class AuthFlowStore {
  email = '';

  constructor() {
    makeAutoObservable(this);
  }

  setEmail(nextEmail: string): void {
    this.email = nextEmail;
  }

  clear(): void {
    this.email = '';
  }
}

export const authFlowStore = new AuthFlowStore();
